import { render, staticRenderFns } from "./userInfoForm.vue?vue&type=template&id=6dc41ccc&scoped=true&"
import script from "./userInfoForm.vue?vue&type=script&lang=js&"
export * from "./userInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./userInfoForm.vue?vue&type=style&index=0&id=6dc41ccc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc41ccc",
  null
  
)

export default component.exports